import { render, staticRenderFns } from "./BrebFile.vue?vue&type=template&id=6140582e&scoped=true&"
import script from "./BrebFile.vue?vue&type=script&lang=js&"
export * from "./BrebFile.vue?vue&type=script&lang=js&"
import style1 from "./BrebFile.vue?vue&type=style&index=1&id=6140582e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6140582e",
  null
  
)

export default component.exports